import React, { SyntheticEvent, useEffect, useRef, useState } from "react";
// import { Loading } from '@q/officeComponent'
// import { listener } from '@q/clientUtil'
import Styles from "./index.module.less";
// import logo from '@/assets/images/login-logo.png'
// import { login, getUser } from '@/api/common'
// import {
//   closeWnd,
//   notifyClientLogout,
//   notifyClientLogin,
//   notifyClientWndSize,
//   moveStart,
//   moveEnd,
// } from '@/utils'
// import { ReactComponent as Close } from '@/assets/svg/login/icon-close.svg'
import { useNavigate } from "react-router-dom";
import { isMobileDevice } from '../../utils/util'
const isLogin = () => {
  return new Promise((resolve) => {
    window.QHPass.getUserInfo(
      false,
      () => {
        resolve(true);
      },
      () => {
        resolve(false);
      }
    );
  });
};
const Login = () => {
  const loginRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // 检测是否是移动端
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  const signIn = () => {
    window.QHPass.signIn(loginRef.current, () => {
      setTimeout(() => {
        const isMobile = isMobileDevice();
        location.href = isMobile ? '/view/complaint_center' : '/view/home';
      }, 300);
    });
  };

  useEffect(() => {
    window.QHPass.init({
      src: "pcw_guanjia",
      signIn: {
        types: ["mobile", "normal"],
        autoreg: 1,
        thirdPart: {
          providers: [],
          mode: 'pop',
          jumpUrl: ''
        }
      },
      signUp: { types: ["mobile"] },
      bindMobile: {
        relMobile: true,
      },
    });

    signIn();

    isLogin()
      .then((login) => {
        if (login) {
          return getUser();
        }
        throw new Error("not login");
      })
      .then((res) => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className={Styles.login}>
      <div className={Styles.loginInner}>
        {!isMobile && (
          <div className={Styles.loginHeader}>
            <div>
              <img
                className={Styles.logo}
                src="https://p5.ssl.qhimg.com/t011ec52c575edc6084.png"
              ></img>
            </div>
            <div>
              <img
                className={Styles.logo_text}
                src="https://p0.ssl.qhimg.com/t0196691e42c6cf9b75.png"
              ></img>
            </div>
          </div>
        )}
        
        <div className={Styles.loginCenter}>
          {!isMobile && (
            <div className={Styles.loginBanner}>
              <div className={Styles.loginDesc}>
                <div className={Styles.mainTitle}>开放互联，畅享无限</div>
                <div className={Styles.subTitle}>体验联运平台的无限可能，在开放的平台上自由获取资源和服务。</div>
              </div>
            </div>
          )}
          
          {isMobile && (
            <div className={Styles.loginDesc}>
              <div className={Styles.mainTitle}>开放互联，畅享无限</div>
              <div className={Styles.subTitle}>体验联运平台的无限可能，在开放的平台上自由获取资源和服务。</div>
            </div>
          )}
          
          <div className="login-box" ref={loginRef}></div>
        </div>
      </div>
    </div>
  );
};
export default Login;
